import React from 'react';
export function PullQuote() {
  return <div className="px-4 py-8 mb-8 text-center relative" data-id="element-136">
      <span className="absolute top-0 left-1/2 -translate-x-1/2 text-6xl font-serif text-brown/10 leading-none" data-id="element-137">
        "
      </span>
      <p className="font-serif text-[22px] md:text-[26px] text-forest italic leading-snug relative z-10 max-w-lg mx-auto mt-4" data-id="element-138">
        Ich wollte doch einfach nur, dass es ihm gut geht — ist das wirklich zu
        viel verlangt?
      </p>
    </div>;
}